import { useState } from 'react';

export interface AlertState {
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
}

export function useAlert() {
  const [alert, setAlert] = useState<AlertState | null>(null);
  const clearAlert = () => setAlert(null);
  return { alert, setAlert, clearAlert } as const;
}
